// Therapist registration

import { createApp } from 'vue/dist/vue.esm-bundler'
import TherapistLpRegistration from '@/components/doctor-therapist-registration/registration-modal/TherapistLpRegistration.vue';

const therapistLpRegistrationModal = document.querySelector('#therapistLpRegistrationModalComponent');

if ( therapistLpRegistrationModal )
{
  createApp({
    components: {
      TherapistLpRegistration
    }
  }).mount('#therapistLpRegistrationModalComponent');
}
